import { KeenIcon } from '@/components';
import { forwardRef } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
  
const TaxesModal = forwardRef(({ 
    open, 
    onCloseModal, 
    handleMode, 
    data, 
    onSubmit,
    createFieldLoading,
    updateFieldLoading
 }, formikRef) => {
    if (!open) return null;
    const isViewMode = handleMode === 'edit';


    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
        rate: Yup.number()
        .typeError('Rate must be a number')
        .required('Rate is required')
        .moreThan(0, 'Rate must be greater than 0')
        .max(100, 'Rate cannot be more than 100'),
        // description: Yup.string()x.required('Description is required'),
    });
    
    const initialValues = {
        name: data?.name || '',
        rate: data?.rate || '',
        description: data?.description || '',
    };
    

  return (
    <div className="modal-wrapper modal-animate-fade">
      
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        innerRef={formikRef}
        onSubmit={(values, formikRef) => {
            onSubmit(values, formikRef)
        }}
      >

        {({ errors, values, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit} className="modal-animate-scale scrollable-y-auto bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border border-gray-300 dark:border-t-light dark:border-light p-6 rounded-lg shadow-lg w-4/5 max-w-xl relative">
                <h3 className="card-title capitalize mb-5">
                    {isViewMode ? 'Edit' : 'Create'} Tax
                    </h3>
                <button
                    type="button"
                    onClick={onCloseModal}
                    className="modal-close-btn"
                    >
                    <KeenIcon icon="cross" />
                </button>
                
                <div className='w-full'>
                    <label className="form-label mb-1">Name <span className='pl-px text-red-600'>*</span></label>
                    <Field name="name" className="input" />
                    <ErrorMessage name="name" component="div" className="text-red-500 text-xs mt-1" />
                </div>

                <div className='w-full my-3'>
                    <label className="form-label mb-1">Rate <span className='pl-px text-red-600'>*</span></label>
                    <Field name="rate" className="input no-spinner" type="number" />
                    <ErrorMessage name="rate" component="div" className="text-red-500 text-xs mt-1" />
                </div>

                <div className='w-full my-3'>
                    <label className="form-label mb-1">Description</label>
                    <Field name="description" as="textarea" rows="4" cols="50" className="min-h-[120px] input py-3 leading-[1.4em]" />
                    <ErrorMessage name="description" component="div" className="text-red-500 text-xs mt-1" />
                </div>

                <button type="submit" disabled={createFieldLoading || updateFieldLoading} className="btn btn-primary justify-center w-full mt-2">
                {isViewMode ? 
                    updateFieldLoading ? 'Please Wait...' : 'Update Tax' 
                : createFieldLoading ? 'Please wait...' : 'Create Tax'}
                </button>
            </Form>
        )}
      </Formik>
    </div>
  );
});

export { TaxesModal };
